export const setSidebarSettings = (sidebarAction) => (dispatch) => {
  dispatch({
    type: "SET_SETTINGS",
    payload: sidebarAction,
  });
};

export const setSettings = (settings) => (dispatch) => {
  dispatch({
    type: "SET_SETTINGS",
    payload: settings,
  });
};

export const toggleIsHorizontal = (isHorizontal) => (dispatch) => {
  dispatch({
    type: "TOGGLE_HORIZONTAL",
    payload: Boolean(isHorizontal),
  });
};
